import { render, staticRenderFns } from "./SkeletonCheckout.vue?vue&type=template&id=4e357cd6"
var script = {}
import style0 from "./SkeletonCheckout.vue?vue&type=style&index=0&id=4e357cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports